export default "__VITE_ASSET__mURD$fyh__"